export const environment = {
    production: true,
    supabaseUrl: 'https://yevtbzntgmemaxsnrfgn.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlldnRiem50Z21lbWF4c25yZmduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkxNjY2NjEsImV4cCI6MjA5NDc0MjY2MX0.nTDcDP82wxQY4fzwms407t2kMFv7Q6qzdrSocmJW9As',
    firebase: {
        vapidKey: 'BKoYCqZjY87SoJnIGbUUH7Ppg2UwN5BzVlaQeSka19i3SqFB9RMtHqxAuD7defDm87_otID6ndodspYdD9tkH2c',
        config: {
            apiKey: "AIzaSyCGMOyiDuqDkZPNrm0y9mIQYDSa_l3RL94",
            authDomain: "time-bank-web-app-dev-19d48.firebaseapp.com",
            projectId: "time-bank-web-app-dev-19d48",
            storageBucket: "time-bank-web-app-dev-19d48.firebasestorage.app",
            messagingSenderId: "204849674553",
            appId: "1:204849674553:web:3d90430f3af47b37fcd0e8",
            measurementId: "G-E6WH4TJ63V"
        }
    }
};
